// Folders in this directory automatically
// get their index.js mounted into vuex as a module

const modules = {}

// Use import.meta.glob instead of require.context for Vite compatibility
const files = import.meta.glob('./*/index.js', { eager: true })

Object.entries(files).forEach(([fileName, module]) => {
  if (fileName === './index.js') return

  const moduleName = module.default?.name ?? fileName.split('/')[1].replace(/-_. /g, '').toLowerCase()

  modules[moduleName] = module.default || module
})

export default modules
